import React from 'react';
import ClinicalNoteForm from '../../../global/component/ClinicalNote/ClinicalNoteForm';
import { ClinicalNoteType } from '../../../global/entities/ClinicalNote/ClinicalNote';

const MedicalHistoryForm: React.FC = () => (
  <ClinicalNoteForm
    config={{
      noteType: ClinicalNoteType.MedicalHistory,
      i18nPrefix: 'medicalHistory',
      returnPath: '/hcpPatientDashboard/medicalInformation',
    }}
  />
);

export default MedicalHistoryForm;
